import React from 'react';
import { Col, Row } from 'reactstrap';
import MenuBar from './MenuBar';
import Feedback from '../Componente/Modais/Feedback';
import Config from '../Util/config';
import HttpUtil from '../Util/httpUtil';

import { AlertasContext } from '../Providers/Alertas';
import { BlockUiContext } from '../Providers/BlockUi';
import { ModalUploadContext } from '../Providers/ModalUpload';

import './Header.scss';

function Header() {
	const nomeUsuario = localStorage.getItem('NomeUsuario');
	const isSimulacao = localStorage.getItem('isSimulacao') === 'true';
	const codUsuarioOld = localStorage.getItem('CodUsuario_OLD');

	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	let ModalFeedback = React.createRef();
	let openModalUpload;
	/* eslint-enable no-unused-vars */

	const abrirSuporteTecnico = () => {
		var url =
			'http://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=2&form[area]=34&form[tipo]=6&form[assunto]=413';
		var win = window.open(url, '_blank');
		win.focus();
	};
	const abrirManual = () => {
        var url = 'https://econeteditora.com.br/manualgnre.pdf';
		var win = window.open(url, '_blank');
		win.focus();
	};

	const retornarEconet = () => {
		window.location.href = 'http://www.econeteditora.com.br/index.asp';
	};

	const sairSimulacao = () => {
		onLoading(true);
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Acesso/ValidarDadosLogin/${codUsuarioOld}`)
			.then(response => {
				onLoading(false);
				localStorage.setItem('CodUsuario_OLD', '');
				localStorage.setItem('CodUsuario', response.data.CodUsuario);
				localStorage.setItem('NomeUsuario', response.data.NomeUsuario);
				localStorage.setItem('Login', response.data.Login);
				localStorage.setItem('Email', response.data.Email);
				localStorage.setItem('NomePerfil', response.data.NomePerfil);
				localStorage.setItem('Administrador', response.data.Administrador);
				localStorage.setItem('isSimulacao', false);
				localStorage.setItem('TermoUso', response.data.TermoUso);
				localStorage.setItem('roles', JSON.stringify(response.data.Roles));
				localStorage.setItem('Hash', response.data.Hash);
				localStorage.setItem('isPro', response.data.isPro);
				localStorage.setItem('AccessToken', response.data.accessToken);
				localStorage.setItem('Token', '');

				window.location = '/simular-acesso';
			})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Erro ao carregar dados');
			});
	};

	return (
		<>
			<Row id="header">
				<AlertasContext.Consumer>
					{alertas => {
						showInfoMessage = alertas.info;
						showSuccessMessage = alertas.success;
						showWarningMessage = alertas.warning;
						showErrorMessage = alertas.error;
					}}
				</AlertasContext.Consumer>
				<BlockUiContext.Consumer>
					{blockUi => {
						onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
				<Feedback ref={ModalFeedback} />
				<ModalUploadContext.Consumer>
					{modalUpload => {
						openModalUpload = modalUpload.openModal;
					}}
				</ModalUploadContext.Consumer>
				<Col>
					<Row>
						<Col sm={11} className="col">
							<Row className="first-line">
								<Col className="huf-blue" />
							</Row>
							<Row className="middle-line">
								<Col className="hcf-blue" />
							</Row>
							<Row className="bottom-line">
								<Col className="hdf-blue" />
							</Row>
						</Col>
						<Col className="header-second-column col" sm={1}>
							<Row className="first-line">
								<div className="fill-side" />
								<Col className="skew-left hus-blue" />
							</Row>
							<Row className="middle-line">
								<Col className="skew-left hcs-blue" />
							</Row>
							<Row className="bottom-line">
								<Col className="skew-left hds-blue" />
							</Row>
						</Col>
					</Row>
				</Col>
				<Col sm={9} className="col header-center-column">
					<Row className="first-line">
						<div className="fill-center" />
						<Col className="hut-blue">
							<Row>
								<Col md={3}>
									<img alt="" src="/img/logo-proj.png" />
								</Col>
								<Col md={3}>
									{isSimulacao && (
										<div className="menu-simulacao ">
											<Row>
												<Col xs={2}>
													<div className="logo">
														<span>S</span>
													</div>
												</Col>
												<Col xs={10}>
													<label className="m-0">{nomeUsuario}</label>
													<div className="sair-simulacao m-0">
														<span className="m-0">Simulando acesso</span>
														<i
															className="fas fa-sign-out-alt ecoico"
															onClick={() => sairSimulacao()}
														/>
													</div>
												</Col>
											</Row>
										</div>
									)}
								</Col>
								<Col md={6}>
									<div className="upload-button" onClick={() => openModalUpload()}>
										<Row>
											<Col md={2} className="upload-icon">
												<i className="ecoico fas fa-cloud-upload-alt" />
											</Col>
											<Col md={10} className="upload-info">
												<h1>Enviar Arquivo XML ou ZIP</h1>
												<p>Clique aqui para enviar os arquivos das suas guias.</p>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row className="middle-line">
						<Col className="hct-blue">
							<Row>
								<Col md={2} className="icons" onClick={() => retornarEconet()}>
									<span>
										<i className="fas fa-chevron-left" />
										Retornar para Econet
									</span>
								</Col>
								<Col md={4} />
								<Col md={2} className="icons blue-border-left" onClick={() => abrirManual()}>
									<span>
										<i className="fas fa-book " />
										Manual do Usuário
									</span>
								</Col>
								<Col className="icons blue-border-left" onClick={() => abrirSuporteTecnico()}>
									<span>
										<i className="fas fa-headset" />
										Suporte Técnico
									</span>
								</Col>
								<Col
									md={2}
									className="icons blue-border-left"
									onClick={() => ModalFeedback.current.openModal()}>
									<span>
										<i className="fas fa-comment-alt" />
										Deixe a sua opinião
									</span>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row className="bottom-line">
						<Col className="hdt-blue">
							<MenuBar />
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col sm={1} className="header-second-column col">
							<Row className="first-line">
								<div className="fill-side" />
								<Col className="skew-right hus-blue">
									<div className="button-bit" />
								</Col>
							</Row>
							<Row className="middle-line">
								<Col className="skew-right hcs-blue" />
							</Row>
							<Row className="bottom-line">
								<Col className="skew-right hds-blue" />
							</Row>
						</Col>
						<Col sm={11} className="col">
							<Row className="first-line">
								<Col className="huf-blue" />
							</Row>
							<Row className="middle-line">
								<Col className="hcf-blue" />
							</Row>
							<Row className="bottom-line">
								<Col className="hdf-blue" />
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row id="header-mobile">
				<Col>
					<MenuBar />
				</Col>
			</Row>
		</>
	);
}

export default Header;
